<script>
import moment from "moment";
import InputRut from "../InputRut.vue";
import InputRegion from "../InputRegion.vue";
import axios from "axios";

export default {
  components: { InputRut, InputRegion },
  name: "FormUsuario",

  props: {
    despacho: Object,
    postInformacionGeneral: Function,
    informacionGeneral: Object,
    editar: Function,
    estados: Object,
  },
  emits: ["update-arrival-date", "update-agent-code"],
  data() {
    return {
      nombre: "",
      nombre_transporte: "",
      numero_manifiesto: "",
      nombre_nave: "",
      cliente_id: 0,
      fecha_eta: "",
      aduana_id: "",
      tipo_carga: "",
      caracteristicas_carga: "",
      transporte: "",
      correo_transporte: "",
      lugar_bl: "",
      pantalla: false,
      visto_bueno: 0,
      editar_visto_bueno: false,
      ref_cliente: "",

      agentCodeEdit: false,
      selectedAgentCode: "",

      arrivalDateEdit: false,
      arrivalDate: undefined,

      agentCodes: [],
    };
  },
  mounted() {
    if (screen.width <= 660) this.pantalla = false;
    else this.pantalla = true;
    this.visto_bueno = this.despacho.requiere_vistos_buenos;

    if (this.despacho.fecha_efectiva_arribo)
      this.arrivalDate = new Date(this.despacho.fecha_efectiva_arribo);

    this.fetchAgentCodes();

    if (this.despacho?.agente?.id) {
      this.selectedAgentCode = this.despacho.agente.id;
    }
  },
  methods: {
    editar_visto_bueno_btn() {
      this.editar_visto_bueno = !this.editar_visto_bueno;
    },
    cambiarRut(value) {
      this.cliente_rut = value;
    },
    cambiarRutTransporte(value) {
      this.transporte = value;
    },
    async fetchAgentCodes() {
      try {
        const { data } = await axios.get(`/api/list?get=["agentes"]`);

        if (data?.data?.agentes) this.agentCodes = [...data?.data?.agentes];

        return true;
      } catch (err) {
        this.$swal({
          icon: "error",
          title: "¡Error!",
          text: "Hubo un error al obtener los códigos de agentes disponibles.",
        });
      }
      return false;
    },
  },
};
</script>

<template>
  <div>
    <div class="flex flex-col gap-2">
      <div v-if="agentCodeEdit == false" class="grid grid-cols-5 gap-4">
        <div class="col-span-1">Código agente</div>
        <div class="col-span-3 text-right">
          {{ despacho.agente.codigo ?? "-" }} -
          {{ despacho.agente.nombre ?? "-" }}
        </div>
        <div class="mx-auto">
          <button
            class="btn-principal"
            @click="() => {
              selectedAgentCode = despacho.agente?.id || '';
              agentCodeEdit = !agentCodeEdit;
            }"
          >
            Editar
            <fas :icon="['fas', 'edit']" />
          </button>
        </div>
      </div>

      <div v-else class="grid grid-cols-2 gap-4 p-4">
        <div>
          <label>Código de agente</label>
          <select v-model="selectedAgentCode">
            <option :selected="!selectedAgentCode" value="">
              Seleccione un agente
            </option>
            <option
              v-for="(agentCode, i) in agentCodes"
              :key="agentCode.value"
              :selected="() => agentCode.id == selectedAgentCode"
              :value="agentCode.value"
            >
              {{ agentCode.key }}
            </option>
          </select>
        </div>
        <div class="flex flex-row mt-auto gap-4">
          <button
            class="btn-principal"
            type="button"
            @click="() => {
              $emit('update-agent-code', selectedAgentCode);
              agentCodeEdit = false;
            }"
          >
            Guardar
          </button>
          <button
            class="btn-secundario"
            type="button"
            @click="() => (agentCodeEdit = !agentCodeEdit)"
          >
            Cancelar
          </button>
        </div>
      </div>

      <!--REFERENCIA CLIENTE -->
      <div
        v-if="despacho.ref_cliente && estados.ref_cliente"
        class="grid grid-cols-5 gap-4"
      >
        <div class="text-left">
          <p>Referencia Cliente</p>
        </div>
        <div class="col-span-3 text-right uppercase font-bold">
          <p v-if="despacho.ref_cliente">{{ despacho.ref_cliente }}</p>
          <p v-else>-</p>
        </div>
        <div class="mx-auto">
          <button
            class="btn-principal"
            @click="editar('pedidor', 'ref_cliente')"
          >
            Editar
            <fas :icon="['fas', 'edit']" />
          </button>
        </div>
      </div>
      <div v-else class="grid grid-cols-2 gap-4 p-4">
        <div>
          <label> Referencia Cliente </label>
          <input
            v-model="ref_cliente"
            :placeholder="despacho.ref_cliente"
            required
          />
        </div>
        <div class="flex flex-row mt-auto gap-4">
          <button
            class="btn-principal"
            type="button"
            @click="
              editar('pedidor', 'ref_cliente', true, {
                ref_cliente: ref_cliente,
              })
            "
          >
            Guardar
          </button>
          <button
            class="btn-secundario"
            type="button"
            @click="editar('pedidor', 'ref_cliente')"
          >
            Cancelar
          </button>
        </div>
      </div>

      <div v-if="!arrivalDateEdit" class="grid grid-cols-5 gap-4">
        <div class="text-left dato">Fecha efectiva de arribo</div>
        <div class="col-span-3 text-right uppercase font-bold">
          {{
            despacho.fecha_efectiva_arribo
              ? moment(despacho.fecha_efectiva_arribo).format("DD-MM-YYYY")
              : "-"
          }}
        </div>
        <div class="mx-auto">
          <button
            type="button"
            @click="
              () => {
                arrivalDateEdit = !arrivalDateEdit;
                if (arrivalDateEdit && despacho.fecha_efectiva_arribo) {
                  arrivalDate = new Date(despacho.fecha_efectiva_arribo);
                } else if (!arrivalDate) {
                  arrivalDate = new Date();
                }
              }
            "
            class="btn-principal"
          >
            Editar
            <fas :icon="['fas', 'edit']"></fas>
          </button>
        </div>
      </div>
      <div v-else class="flex flex-row gap-4 p-4">
        <div>
          <label>Fecha efectiva de arribo</label>
          <b-form-datepicker
            cols="4"
            v-model="arrivalDate"
            class="ml-auto font-bold"
          >
          </b-form-datepicker>
        </div>
        <div class="flex flex-row gap-4 mt-auto">
          <button
            type="button"
            @click="() => {
              $emit('update-arrival-date', arrivalDate);
              arrivalDateEdit = false;
            }"
            class="btn-principal"
          >
            Guardar
          </button>
          <button
            @click="
              () => {
                arrivalDateEdit = false;
              }
            "
            class="btn-secundario"
          >
            Cancelar
          </button>
        </div>
      </div>

      <div
        v-if="despacho.tipo.nombre_transporte && estados.nombre_transporte"
        class="grid grid-cols-5 gap-4"
      >
        <div class="text-left">
          <p>Medio de Transporte</p>
        </div>
        <div class="col-span-3 text-right uppercase font-bold">
          <p v-if="despacho.tipo.nombre_transporte">
            {{ despacho.tipo.nombre_transporte }} -
            {{ despacho.tipo.numero_manifiesto }}
          </p>
          <p v-else>-</p>
        </div>
        <div class="mx-auto">
          <button
            v-if="pantalla == true"
            @click="editar('pedidor', 'nombre_transporte')"
            class="btn-principal"
          >
            Editar
            <fas :icon="['fas', 'edit']" />
          </button>
          <button
            v-if="pantalla == false"
            @click="editar('pedidor', 'nombre_transporte')"
            class="btn-principal-chico"
          >
            <inline-svg
              class="icono-titulo"
              src="../../assets/images/EditarAzul.svg"
              title="My Image"
            />
          </button>
        </div>

        <div v-if="despacho.tipo.nombre_nave !== null" class="text-left">
          <p>Nombre de Nave</p>
        </div>
        <div v-if="despacho.tipo.nombre_nave !== null" class="text-right">
          <p>{{ despacho.tipo.nombre_nave }}</p>
        </div>
      </div>
      <div v-else class="grid grid-cols-3 p-4 gap-4">
        <div>
          <label> Medio de Transporte </label>

          <select id="importancia-select" v-model="nombre_transporte" required>
            <option value="0" disabled>
              Selecciona el Medio de Transporte
            </option>
            <option
              :key="index"
              v-for="(
                nombreTrasporte, index
              ) in informacionGeneral.nombre_transporte"
              :value="nombreTrasporte"
            >
              {{ nombreTrasporte }}
            </option>
          </select>
        </div>

        <div>
          <label
            >Número Manifiesto
            <fas id="icon" icon="exclamation-circle"></fas>
            <b-tooltip target="icon" placement="top">
              De no contar con Número de Manifiesto, ingresar
              <strong>'0000'</strong>
            </b-tooltip>
          </label>
          <input type="text" v-model="numero_manifiesto" required />
        </div>

        <div class="flex flex-row mt-auto gap-4">
          <button
            class="btn-principal"
            type="button"
            @click="
              editar('pedidor', 'nombre_transporte', true, {
                nombre_transporte: nombre_transporte,
                numero_manifiesto: numero_manifiesto,
                nombre_nave: nombre_nave,
              })
            "
          >
            Guardar
          </button>
          <button
            class="btn-secundario"
            type="button"
            @click="editar('pedidor', 'nombre_transporte')"
          >
            Cancelar
          </button>
        </div>
        <div v-if="nombre_transporte === 'MARÍTIMO'" sm="12" md="12" lg="4">
          <b-form-group class="text-left" label-for="numero_manifiesto-select">
            <template slot="label"
              >Nombre de Nave
              <!-- <fas id="icon" icon="exclamation-circle"></fas> -->
              <!-- <b-tooltip target="icon" placement="top">
                                    De no contar con Número de Manifiesto, ingresar <strong>'0000'</strong>
                                </b-tooltip> -->
            </template>
            <input type="text" v-model="nombre_nave" />
          </b-form-group>
        </div>
      </div>
      <div v-if="!editar_visto_bueno" class="grid grid-cols-5 gap-4">
        <div class="text-left text-nowrap">
          <p>Requiere Vistos Buenos(CDA)</p>
        </div>
        <div class="col-span-3 text-right uppercase font-bold">
          <p v-if="despacho.requiere_vistos_buenos">Sí</p>
          <p v-else>No</p>
        </div>
        <div class="mx-auto">
          <button
            v-if="pantalla == true"
            @click="editar_visto_bueno_btn()"
            class="btn-principal"
          >
            Editar
            <fas :icon="['fas', 'edit']" />
          </button>
          <button
            v-if="pantalla == false"
            @click="editar_visto_bueno_btn()"
            class="btn-principal-chico"
          >
            <inline-svg
              class="icono-titulo"
              src="../../assets/images/EditarAzul.svg"
              title="My Image"
            />
          </button>
        </div>
      </div>
      <div v-else class="grid grid-cols-2 gap-4 p-4">
        <div>
          <b-form-group
            class="text-left"
            label="Requiere vistos buenos(CDA)"
            label-for="requiere_visto_bueno-select"
          >
            <select
              id="requiere_visto_bueno-select"
              v-model="visto_bueno"
              required
            >
              <option value="0">No</option>
              <option value="1">Sí</option>
            </select>
          </b-form-group>
        </div>
        <div class="flex flex-row mt-auto gap-4">
          <button
            class="btn-principal"
            type="button"
            @click="
              editar('pedidor', 'requiere_vistos_buenos', true, {
                requiere_vistos_buenos: visto_bueno,
              })
            "
          >
            Guardar
          </button>
          <button
            class="btn-secundario"
            type="button"
            @click="editar_visto_bueno_btn()"
          >
            Cancelar
          </button>
        </div>
      </div>

      <div
        v-if="despacho.tipo.tipo_carga && estados.tipo_carga"
        class="grid grid-cols-5 gap-4"
      >
        <div class="text-left">
          <p>Tipo de Carga</p>
        </div>
        <div class="col-span-3 text-right uppercase font-bold">
          <p v-if="despacho.tipo.tipo_carga">{{ despacho.tipo.tipo_carga }}</p>
          <p v-else>-</p>
        </div>
        <div class="mx-auto">
          <button
            v-if="pantalla == true"
            @click="editar('pedidor', 'tipo_carga')"
            class="btn-principal"
          >
            Editar
            <fas :icon="['fas', 'edit']" />
          </button>
          <button
            v-if="pantalla == false"
            @click="editar('pedidor', 'tipo_carga')"
            class="btn-principal-chico"
          >
            <inline-svg
              class="icono-titulo"
              src="../../assets/images/EditarAzul.svg"
              title="My Image"
            />
          </button>
        </div>
      </div>
      <div v-else class="grid grid-cols-2 gap-4 p-4">
        <div>
          <b-form-group
            class="text-left"
            label="Tipo de Carga"
            label-for="importancia-select"
          >
            <select id="importancia-select" v-model="tipo_carga" required>
              <option value="0" disabled>Selecciona el Tipo de Carga</option>
              <option
                :key="index"
                v-for="(tipo_carga, index) in informacionGeneral.tipo_carga"
                :value="tipo_carga"
              >
                {{ tipo_carga }}
              </option>
            </select>
          </b-form-group>
        </div>
        <div class="flex flex-row mt-auto gap-4">
          <button
            class="btn-principal"
            type="button"
            @click="
              editar('pedidor', 'tipo_carga', true, {
                tipo_carga: tipo_carga,
              })
            "
          >
            Guardar
          </button>
          <button
            class="btn-secundario"
            type="button"
            @click="editar('pedidor', 'tipo_carga')"
          >
            Cancelar
          </button>
        </div>
      </div>

      <div
        v-if="
          despacho.tipo.caracteristicas_carga && estados.caracteristicas_carga
        "
        class="grid grid-cols-5 gap-4"
      >
        <div class="text-left">
          <p>Características Carga</p>
        </div>
        <div class="col-span-3 text-right uppercase font-bold">
          <p v-if="despacho.tipo.caracteristicas_carga">
            {{ despacho.tipo.caracteristicas_carga }}
          </p>
          <p v-else>-</p>
        </div>
        <div class="mx-auto">
          <button
            v-if="pantalla == true"
            @click="editar('pedidor', 'caracteristicas_carga')"
            class="btn-principal"
          >
            Editar
            <fas :icon="['fas', 'edit']" />
          </button>
          <button
            v-if="pantalla == false"
            @click="editar('pedidor', 'caracteristicas_carga')"
            class="btn-principal-chico"
          >
            <inline-svg
              class="icono-titulo"
              src="../../assets/images/EditarAzul.svg"
              title="My Image"
            />
          </button>
        </div>
      </div>
      <div v-else class="grid grid-cols-2 gap-4 p-4">
        <div>
          <label> Características Carga </label>

          <select
            id="importancia-select"
            v-model="caracteristicas_carga"
            required
          >
            <option value="0" disabled>Selecciona Característica Carga</option>
            <option
              :key="index"
              v-for="(
                caracteristicas_carga, index
              ) in informacionGeneral.caracteristicas_carga"
              :value="caracteristicas_carga"
            >
              {{ caracteristicas_carga }}
            </option>
          </select>
        </div>
        <div class="flex flex-row mt-auto gap-4">
          <button
            class="btn-principal"
            type="button"
            @click="
              editar('pedidor', 'caracteristicas_carga', true, {
                caracteristicas_carga: caracteristicas_carga,
              })
            "
          >
            Guardar
          </button>
          <button
            class="btn-secundario"
            type="button"
            @click="editar('pedidor', 'caracteristicas_carga')"
          >
            Cancelar
          </button>
        </div>
      </div>

      <div
        v-if="despacho.tipo.aduana && estados.aduana"
        class="grid grid-cols-5 gap-4"
      >
        <div class="text-left">
          <p>Aduana</p>
        </div>
        <div class="col-span-3 text-right uppercase font-bold">
          <p>{{ despacho.tipo.aduana.nombre }}</p>
        </div>
        <div class="mx-auto">
          <button
            v-if="pantalla == true"
            @click="editar('pedidor', 'aduana')"
            class="btn-principal"
          >
            Editar
            <fas :icon="['fas', 'edit']" />
          </button>
          <button
            v-if="pantalla == false"
            @click="editar('pedidor', 'aduana')"
            class="btn-principal-chico"
          >
            <inline-svg
              class="icono-titulo"
              src="../../assets/images/EditarAzul.svg"
              title="My Image"
            />
          </button>
        </div>
      </div>
      <div v-else class="grid grid-cols-2 gap-4 p-4">
        <div>
          <label> Aduana </label>

          <select id="importancia-select" v-model="aduana_id" required>
            <option value="0" disabled>Selecciona una Aduana</option>
            <option
              :key="index"
              v-for="(aduana, index) in informacionGeneral.aduana"
              :value="aduana.id"
            >
              {{ aduana.nombre }}
            </option>
          </select>
        </div>
        <div class="flex flex-row mt-auto gap-4">
          <button
            class="btn-principal"
            type="button"
            @click="
              editar('pedidor', 'aduana', true, { aduanas_id: aduana_id })
            "
          >
            Guardar
          </button>
          <button
            class="btn-secundario"
            type="button"
            @click="editar('pedidor', 'aduana')"
          >
            Cancelar
          </button>
        </div>
      </div>

      <div
        v-if="despacho.tipo.fecha_eta && estados.fecha_eta"
        class="grid grid-cols-5 gap-4"
      >
        <div class="text-left">
          <p>Fecha Eta</p>
        </div>
        <div class="col-span-3 text-right uppercase font-bold">
          <p v-if="despacho.tipo.fecha_eta">
            {{ moment(despacho.tipo.fecha_eta).format("DD-MM-YYYY") }}
          </p>
          <p v-else>-</p>
        </div>
        <div class="mx-auto">
          <button
            v-if="pantalla == true"
            @click="editar('pedidor', 'fecha_eta')"
            class="btn-principal"
          >
            Editar
            <fas :icon="['fas', 'edit']" />
          </button>
          <button
            v-if="pantalla == false"
            @click="editar('pedidor', 'fecha_eta')"
            class="btn-principal-chico"
          >
            <inline-svg
              class="icono-titulo"
              src="../../assets/images/EditarAzul.svg"
              title="My Image"
            />
          </button>
        </div>
      </div>
      <div v-else class="grid grid-cols-2 gap-4 p-4">
        <div>
          <label> Fecha ETA </label>

          <input type="date" v-model="fecha_eta" required />
        </div>
        <div class="flex flex-row mt-auto gap-4">
          <button
            class="btn-principal"
            type="button"
            @click="
              editar('pedidor', 'fecha_eta', true, {
                fecha_eta: fecha_eta,
              })
            "
          >
            Guardar
          </button>
          <button
            class="btn-secundario"
            type="button"
            @click="editar('pedidor', 'fecha_eta')"
          >
            Cancelar
          </button>
        </div>
      </div>

      <div
        v-if="despacho.transporte && estados.transporte"
        hidden
        class="grid grid-cols-5 gap-4"
      >
        <div class="text-left">
          <p>Transporte</p>
        </div>
        <div class="col-span-3 text-right uppercase font-bold">
          <p v-if="despacho.transporte">
            {{ despacho.transporte }} - {{ despacho.correo_transporte }}
          </p>
          <p v-else>-</p>
        </div>
        <div class="mx-auto">
          <button
            v-if="pantalla == true"
            @click="editar('pedidor', 'transporte')"
            class="btn-principal"
          >
            Editar
            <fas :icon="['fas', 'edit']" />
          </button>
          <button
            v-if="pantalla == false"
            @click="editar('pedidor', 'transporte')"
            class="btn-principal-chico"
          >
            <inline-svg
              class="icono-titulo"
              src="../../assets/images/EditarAzul.svg"
              title="My Image"
            />
          </button>
        </div>
      </div>
      <div v-else hidden>
        <div>
          <label> Nombre de Transporte Local (Chile) </label>

          <input type="text" v-model="transporte" required />
        </div>
        <div>
          <label> Correo de Transporte Local </label>

          <input type="email" v-model="correo_transporte" required />
        </div>

        <div class="flex flex-row mt-auto gap-4">
          <button
            class="btn-principal"
            type="button"
            @click="
              editar('pedidor', 'transporte', true, {
                transporte: transporte,
                correo_transporte: correo_transporte,
              })
            "
          >
            Guardar
          </button>
          <button
            class="btn-secundario"
            type="button"
            @click="editar('pedidor', 'transporte')"
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
    <div v-if="despacho.tipo.nombre_transporte == 'MARÍTIMO'" hidden>
      <div
        v-if="despacho.lugar_bl && estados.lugar_bl"
        class="grid grid-cols-5 gap-4"
      >
        <div class="text-left">
          <p>Lugar Bl</p>
        </div>
        <div class="col-span-3 text-right uppercase font-bold">
          <p v-if="despacho.lugar_bl">{{ despacho.lugar_bl }}</p>
          <p v-else>-</p>
        </div>
        <div class="mx-auto">
          <button
            v-if="pantalla == true"
            @click="editar('pedidor', 'lugar_bl')"
            class="btn-principal"
          >
            Editar
            <fas :icon="['fas', 'edit']" />
          </button>
          <button
            v-if="pantalla == false"
            @click="editar('pedidor', 'lugar_bl')"
            class="btn-principal-chico"
          >
            <inline-svg
              class="icono-titulo"
              src="../../assets/images/EditarAzul.svg"
              title="My Image"
            />
          </button>
        </div>
      </div>

      <div v-else class="grid grid-cols-2 gap-4 p-4">
        <div>
          <label> Lugar Bl </label>

          <select id="lugarbl-select" v-model="lugar_bl" required>
            <option value="0" disabled>Selecciona el Lugar Bl</option>
            <option
              :key="index"
              v-for="(lugarBl, index) in informacionGeneral.lugar_bl"
              :value="lugarBl"
            >
              {{ lugarBl }}
            </option>
          </select>
        </div>
        <div class="flex flex-row mt-auto gap-4">
          <button
            class="btn-principal"
            type="button"
            @click="editar('pedidor', 'lugar_bl', true, { lugar_bl: lugar_bl })"
          >
            Guardar
          </button>
          <button
            class="btn-secundario"
            type="button"
            @click="editar('pedidor', 'lugar_bl')"
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
